export var EActiveFlow;
(function (EActiveFlow) {
  EActiveFlow["Authentication"] = "authentication";
  EActiveFlow["Registration"] = "registration";
})(EActiveFlow || (EActiveFlow = {}));